export const groupItemsByType = (items) => {
    const typeOrder = [];
    const typeMap = new Map();

    items.forEach((item) => {
        if (!typeMap.has(item.Type)) {
            typeMap.set(item.Type, { descOrder: [], descMap: new Map() });
            typeOrder.push(item.Type);
        }
        const typeEntry = typeMap.get(item.Type);
        const descKey = item.Description || "";
        if (!typeEntry.descMap.has(descKey)) {
            typeEntry.descMap.set(descKey, []);
            typeEntry.descOrder.push(descKey);
        }
        typeEntry.descMap.get(descKey).push(item);
    });

    return typeOrder.map((type) => {
        const { descOrder, descMap } = typeMap.get(type);
        const groups = descOrder.map((desc) => ({ description: desc, items: descMap.get(desc) }));
        const itemCount = groups.reduce((sum, g) => sum + g.items.length, 0);
        const groupCount = groups.filter((g) => g.description).length;
        return { type, groups, itemCount, groupCount };
    });
};